module.exports = __webpack_public_path__ + "img/color-yellow.b603ee47.jpg";